'use strict';

module.exports = {
  init({ goodsShipping }) {
    if (!goodsShipping) {
      return;
    }

    const $container = document.querySelector('#goods-shipping');
    const $shippingValue = $container.querySelector('.shipping-value');

    window.DealEventPipe.on('goodsOptionUpdate', ({ uuid }) => {
      const shippingValue = goodsShipping[uuid];
      if (shippingValue) {
        $container.classList.remove('hidden');
        $shippingValue.textContent = shippingValue;
      } else {
        $container.classList.add('hidden');
      }
    });
  },
};
